const msalHashParamNames = [
    'code',
    'error',
    'error_description',
    'state',
    'client_info',
    'id_token',
    'access_token',
    'session_state'
] as const;

export function hashContainsKnownMsalProperties(hash: string): boolean {
    if (!hash) {
        return false;
    }

    const trimmed = hash.startsWith('#') ? hash.substring(1) : hash;
    const normalized = trimmed.startsWith('/') ? trimmed.substring(1) : trimmed;
    const hashParams = new URLSearchParams(normalized);

    return msalHashParamNames.some(param => hashParams.has(param));
}
